// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__1+Y0K","copyright":"Footer_copyright__Xw3A0","links":"Footer_links__tDit4"};